export default __webpack_public_path__ + "static/media/drag_move2.93d13042.svg";